import React, { ReactNode } from 'react';
import { Modal, Typography } from '@fullstory/components';
import { useIntl } from 'react-intl';

export interface ConfirmActionType {
  action: () => void;
  variant?: React.ComponentProps<typeof Modal.FooterActions>['primaryAction']['variant'];
  text?: string;
}

export interface ConfirmModalProps {
  testId?: string;
  title: string;
  /**
   * If just passed a function, the primary action button
   * will have no intent and a text value of 'Confirm'
   * An object may be passed instead to override the
   * intent and text of the button
   */
  confirmAction: ConfirmActionType | ConfirmActionType['action'];
  onHide: () => void;
  message?: string;
  children?: ReactNode;
  open?: boolean;
}
export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  testId,
  title,
  confirmAction,
  onHide,
  message,
  children,
  open,
}) => {
  const intl = useIntl();
  const confirmMessage = intl.formatMessage({ defaultMessage: 'Confirm', id: 'N2IrpM' });
  return (
    <Modal
      testId={testId}
      disableBackdropClick
      size="small"
      onCloseSignal={() => onHide()}
      open={open}
    >
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>
        {message && <Typography variant="body2">{message}</Typography>}
        {children && <>{children}</>}
      </Modal.Body>
      <Modal.FooterActions
        primaryAction={
          typeof confirmAction === 'function'
            ? {
                action: confirmAction,
                text: confirmMessage,
              }
            : {
                text: confirmAction.text ?? confirmMessage,
                ...confirmAction,
              }
        }
        secondaryAction={{
          action: () => onHide(),
          text: intl.formatMessage({ defaultMessage: 'Cancel', id: '47FYwb' }),
        }}
      />
    </Modal>
  );
};
